<ion-header>
  <ion-toolbar>
    <ion-title [innerHTML]="video.title"></ion-title>

    <ion-buttons slot="end">
      <ion-button (click)="cancel()">
        Close
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="exercise-modal-body">
    <div class="video-slide-container">
      <ion-card>
        <div class="video-transition-overlay" [class.visible]="isLoading"
          [style.width.px]="vimeowidth()" [style.height.px]="vimeoheight()">
          <div class="overlay-content">
            <svg class="play-icon" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="24" cy="24" r="23" stroke="rgba(255,255,255,0.15)" stroke-width="2"/>
              <path d="M19 14.5v19l15-9.5-15-9.5z" fill="rgba(255,255,255,0.2)"/>
            </svg>
            <div class="loading-dots">
              <span></span><span></span><span></span>
            </div>
          </div>
        </div>
        <iframe #videoIframe [src]="vimeourl"
          [width]="vimeowidth()" [height]="vimeoheight()" frameborder="0"
          allow="autoplay; fullscreen" allowfullscreen
          referrerpolicy="no-referrer" loading="lazy"
          (load)="onIframeLoaded()"></iframe>
      </ion-card>
    </div>
    <app-video-instructions [videoWidth]="vimeowidth()"></app-video-instructions>
  </div>
</ion-content>
<ion-footer class="exercise-footer">
  <div *ngIf="exercise && exercise.type == 'progressive'" class="divider-padding exercise-footer-actions">
    <ion-button [disabled]="exercise.istail || isBusy" class="left-button big-text-btn" color="success" (click)="toohard()"> < Easier </ion-button>
    <span class="step-button" [innerHTML]="step"></span>
    <ion-button [disabled]="exercise.istop || isBusy" class="right-button big-text-btn" color="danger" (click)="tooeasy()"> Harder > </ion-button>
  </div>

  <div *ngIf="exercise && exercise.type != 'progressive'" class="divider-padding exercise-footer-actions">
    <ion-button [disabled]="exercise.istail || isBusy" class="left-button big-text-btn" color="danger" (click)="toohard()">Previous</ion-button>
    <span class="step-button" [innerHTML]="step"></span>
    <ion-button [disabled]="exercise.istop || isBusy" class="right-button big-text-btn" color="success" (click)="tooeasy()">Next</ion-button>
  </div>
</ion-footer>